const options = {
    summaryCredit: [
        {
            label: 'Monto aprobado',
            name: 'monto_aprobado',
        },
        {
            label: 'Fondo de garantías',
            name: 'fondo_garantias',
        },
    ],
    monthlyValues: [
        {
            label: 'Cuota mensual',
            name: 'total_cuota',
        },
        {
            label: 'Seguro de vida deudor',
            name: 'seguro_vida_deudor',
        },
    ],
};

export default options;